import { render } from "./NkEvent.vue?vue&type=template&id=d82fd084"
const script = {}

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__